<template>
  <header :class="['info-pages', headerScrolled || !menuFolded ? 'scrolled' : '']">
    <div class="container">
      <svg class="logo" @click="logoNav()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 121 24" width="121" height="24">
        <path :fill="logoColor && headerScrolled || !menuFolded ? '#000' : logoColor" d="M35.1857 7.19828c.7372 0 1.3725.12549 1.9058.37645.5411.25096.9529.6078 1.2352 1.07051.2823.45487.4235.98817.4235 1.59986 0 .6039-.1412 1.1372-.4235 1.5999-.2823.4549-.6941.8078-1.2352 1.0588-.5333.2509-1.1686.3764-1.9058.3764h-3.8232v-1.9528h3.6703c.3921 0 .698-.0941.9176-.2823.2196-.1961.3294-.4627.3294-.8 0-.34504-.1098-.61169-.3294-.79991-.2196-.19607-.5255-.2941-.9176-.2941h-3.4586l1.0941-1.12933v7.99944h-2.4352V7.19828h4.9526Zm10.3962 8.82292-.3059-2.4234.3177-.9293-.3177-.9294.3059-2.43508h2.4939l-.4235 3.35268.4235 3.3645h-2.4939Zm.5647-3.3527c-.1098.7058-.3294 1.3254-.6588 1.8587-.3216.5333-.7333.9489-1.2352 1.247-.4941.2901-1.0588.4352-1.694.4352-.6588 0-1.2392-.1451-1.7411-.4352-.4941-.2981-.8823-.7137-1.1646-1.247-.2823-.5412-.4235-1.1607-.4235-1.8587 0-.7137.1412-1.3372.4235-1.8705.2823-.5333.6705-.94892 1.1646-1.24694.5019-.29802 1.0823-.44702 1.7411-.44702.6352 0 1.1999.149 1.694.44702.5019.29018.9176.70194 1.2469 1.23524.3294.5254.5451 1.1528.6471 1.8822Zm-4.4821 0c0 .3294.0667.6235.2.8823.1412.2588.3333.4627.5764.6117.2432.1412.5216.2118.8353.2118.3294 0 .6391-.0706.9293-.2118.2902-.149.5451-.3529.7647-.6117.2196-.2588.3843-.5529.4941-.8823-.1098-.3372-.2745-.6353-.4941-.8941-.2196-.2588-.4745-.4627-.7647-.6117-.2902-.149-.5999-.2235-.9293-.2235-.3137 0-.5921.0745-.8353.2235-.2431.149-.4352.3529-.5764.6117-.1333.2588-.2.5569-.2.8941Zm6.978-1.5881v-1.047l1.3646-.55292 1.0353-1.9881h1.3646v1.81164h2.8233v1.77638H52.407v1.9175c0 .5098.098.8666.2941 1.0705.196.2039.5529.3059 1.0705.3059.3294 0 .6195-.0275.8705-.0824.2588-.0549.4941-.1294.7058-.2235v1.7999c-.2431.0862-.5568.1647-.9411.2352-.3764.0706-.7725.1059-1.1881.1059-.7372 0-1.345-.1137-1.8234-.3411-.4706-.2275-.8196-.5529-1.047-.9764-.2274-.4314-.3412-.9333-.3412-1.5058v-2.3057h-1.3646Zm6.2114 0V9.30402h2.4351l-1.5881 1.10578 1.5528-2.91742h1.3646v1.81164h2.8233v1.77638h-2.8233v1.9175c0 .5098.098.8666.2941 1.0705.1961.2039.5568.3059 1.0823.3059.3294 0 .6195-.0275.8705-.0824.251-.0549.4823-.1294.6941-.2235v1.7999c-.2431.0862-.5568.1647-.9411.2352-.3765.0706-.7725.1059-1.1882.1059-.7372 0-1.345-.1137-1.8234-.3411-.4705-.2275-.8195-.5529-1.047-.9764-.2274-.4314-.3411-.9333-.3411-1.5058v-2.3057h-1.3646Zm11.4142 5.129c-.8156 0-1.545-.149-2.188-.447-.6353-.298-1.1372-.7137-1.5058-1.247-.3686-.5411-.5529-1.1685-.5529-1.8822 0-.698.1764-1.3097.5293-1.8352.353-.5333.8353-.94892 1.447-1.24694.6196-.29802 1.3176-.44702 2.094-.44702.8078 0 1.494.17645 2.0587.52937.5725.34507 1.0117.83519 1.3175 1.47049.3137.6352.4706 1.3842.4706 2.2469h-5.9761v-1.447h4.6232l-.7882.5059c-.0313-.3451-.1176-.6353-.2588-.8705-.1411-.2432-.3294-.4275-.5646-.5529-.2275-.1255-.502-.1883-.8235-.1883-.3529 0-.6549.0706-.9058.2118-.251.1412-.447.3372-.5882.5882-.1412.2431-.2118.5294-.2118.8587 0 .4235.0941.7843.2824 1.0823.196.2902.4784.5137.847.6706.3764.1568.8352.2352 1.3763.2352.4941 0 .9843-.0627 1.4705-.1882.4941-.1333.9411-.3176 1.3411-.5529v1.5293c-.4627.3137-.9921.5568-1.5881.7294-.5882.1647-1.2235.247-1.9058.247Zm4.3462-6.90538h2.4468l.4 2.39988v4.3173h-2.3998v-4.4585l-.447-2.25868Zm5.9995-.10587v2.04695c-.2352-.0471-.4588-.0785-.6705-.0941-.2039-.0236-.3921-.0353-.5647-.0353-.345 0-.6627.0705-.9528.2117-.2902.1333-.5255.3568-.7059.6706-.1725.3137-.2588.7332-.2588 1.2587l-.4588-.5647c.0628-.4862.1569-.9411.2824-1.3646.1254-.4313.2941-.8117.5058-1.1411.2196-.33722.4902-.59995.8117-.78817.3216-.19606.7137-.29409 1.1764-.29409.1333 0 .2706.00784.4117.02352.1412.01569.2824.03922.4235.07059Zm.5028.10587h2.4116l.4352 2.68218v4.035h-2.3998v-4.3997l-.447-2.31748Zm5.3172-.19998c.6431 0 1.1921.1294 1.647.3882.4549.25881.7999.62346 1.0352 1.09406.2431.4705.3647 1.0274.3647 1.6705v3.7644h-2.3998v-3.4115c0-.502-.1295-.8862-.3883-1.1529-.2509-.2666-.6156-.4-1.094-.4-.3294 0-.6196.0706-.8705.2118-.2431.1412-.4314.3411-.5647.5999-.1333.2589-.2.5647-.2.9176l-.7411-.3882c.0941-.7137.2941-1.3136.6-1.7999.3058-.494.6823-.86656 1.1293-1.11752.447-.25096.9411-.37644 1.4822-.37644Zm5.5438 1.70576h6.3995v2.0587h-6.3995v-2.0587Zm6.623-3.61152v2.05869h-6.5407l1.1646-1.16463v7.92886h-2.4351V7.19828h7.8112Zm7.0094 8.82292-.306-2.4234.317-.9293-.317-.9294.306-2.43508h2.494l-.424 3.35268.424 3.3645h-2.494Zm.564-3.3527c-.109.7058-.329 1.3254-.658 1.8587-.322.5333-.734.9489-1.236 1.247-.4937.2901-1.0584.4352-1.6936.4352-.6588 0-1.2391-.1451-1.7411-.4352-.494-.2981-.8823-.7137-1.1646-1.247-.2823-.5412-.4235-1.1607-.4235-1.8587 0-.7137.1412-1.3372.4235-1.8705.2823-.5333.6706-.94892 1.1646-1.24694.502-.29802 1.0823-.44702 1.7411-.44702.6352 0 1.1999.149 1.6936.44702.502.29018.918.70194 1.247 1.23524.33.5254.545 1.1528.647 1.8822Zm-4.4817 0c0 .3294.0667.6235.2.8823.1412.2588.3333.4627.5765.6117.2431.1412.5215.2118.8352.2118.3294 0 .6392-.0706.929-.2118.291-.149.545-.3529.765-.6117.22-.2588.384-.5529.494-.8823-.11-.3372-.274-.6353-.494-.8941-.22-.2588-.474-.4627-.765-.6117-.2898-.149-.5996-.2235-.929-.2235-.3137 0-.5921.0745-.8352.2235-.2432.149-.4353.3529-.5765.6117-.1333.2588-.2.5569-.2.8941Zm15.3307 1.1646c0 .5176-.157.9529-.47 1.3058-.314.3529-.761.6196-1.341.8-.581.1803-1.279.2705-2.094.2705-.84 0-1.577-.1019-2.212-.3058-.627-.2039-1.118-.4902-1.47-.8588-.353-.3686-.542-.796-.565-1.2823h2.435c.055.1804.161.3373.318.4706.164.1255.38.2235.647.2941.266.0627.584.0941.953.0941.478 0 .839-.0471 1.082-.1412.251-.0941.376-.2352.376-.4235 0-.149-.094-.2588-.282-.3294-.188-.0784-.51-.1372-.965-.1764l-1.188-.0941c-.792-.0549-1.423-.1726-1.894-.3529-.463-.1883-.796-.4275-1-.7176-.204-.2981-.306-.6353-.306-1.0117 0-.5098.157-.9294.471-1.2588.321-.3372.765-.58817 1.329-.75286.573-.17254 1.239-.2588 2-.2588.753 0 1.424.09803 2.012.29409.588.19607 1.058.47056 1.411.82347.353.3451.557.7529.612 1.2234h-2.435c-.039-.149-.126-.2823-.259-.3999-.133-.1255-.317-.2275-.553-.3059-.235-.0784-.537-.1176-.906-.1176-.431 0-.76.047-.988.1411-.219.0942-.329.2275-.329.4 0 .1333.067.2392.2.3176.141.0785.4.1334.776.1647l1.565.1177c.776.047 1.388.1607 1.835.3411.447.1726.765.4039.953.6941.188.2902.282.6352.282 1.0352Zm.321-2.7527v-1.047l1.365-.55292 1.035-1.9881h1.364v1.81164h2.824v1.77638h-2.824v1.9763c0 .4862.098.8274.294 1.0235.197.196.553.2941 1.071.2941.329 0 .62-.0275.87-.0824.259-.0627.495-.1412.706-.2353v1.8117c-.235.0862-.545.1647-.929.2352-.384.0706-.78.1059-1.188.1059-.745 0-1.357-.1137-1.835-.3411-.471-.2275-.82-.5529-1.047-.9764-.228-.4314-.341-.9333-.341-1.5058v-2.3057h-1.365Z"/>
        <path fill="#F24C57" d="M6.83301.8974c1.35475-.404942 2.84127-.283462 4.08109.2998 2.217 1.02081 5.1565 2.39857 7.3652 3.43555-1.2399-.58332-2.7344-.70488-4.0811-.2998-3.1284.94788-6.89754 5.04704-6.83199 8.49025l.23828 10.5166-7.365232-3.4434-.038086-1.6543 1.059568.4766v-.8975l-1.080076-.4853-.038086-1.6709 2.588872 1.1631v-.8975L.12207 14.7578l-.0380856-1.7042 1.3867156.6241v-.8975l-1.4072234-.6328-.06250004-2.75879C-.0647123 5.94538 3.70451 1.8372 6.83301.8974ZM13.623 5.12689c.7965-.4699 1.9796-.71371 3.7286-.1709 1.7161.53472 2.8322 1.73444 3.5713 3.04688.041.22683.0747.46176.083.71289.0738 3.53234-2.3654 7.15404-5.42 8.17484l-7.3652-3.4434c3.0545-1.029 5.4846-4.65064 5.4189-8.1748 0-.0485-.0165-.09701-.0166-.14551Z"/>
      </svg>
      <div class="nav-profile">
        <nav>
          <RouterLink :to="{ name: 'faq' }">FAQs</RouterLink>
          <RouterLink :to="{ name: 'pricing' }">Pricing</RouterLink>
          <a href="http://clear.co/partner/patternfast" target="_blank">Funding</a>
          <RouterLink v-if="!userStore.isLoggedIn" :to="{ name: 'signIn' }">Log in</RouterLink>
          <div v-if="!userStore.isLoggedIn" class="nav-profile__buttons">
            <ButtonSecondary class="small" @click.native="$router.push({ name: 'signUp' })">Sign Up</ButtonSecondary>
            <ButtonPrimary class="small" @click.native="$router.push({ name: 'demo' })">Request a Demo</ButtonPrimary>
          </div>
        </nav>
        <div class="profile" v-if="userStore.isLoggedIn" @click="$router.push({ name: 'userProfile' })">
          <span class="name">{{ userStore.data.firstName }} {{ userStore.data.lastName }}</span>
          <figure>
            <img :src="userStore.userPic.data" v-if="userStore.userPic.type === 'image'">
            <div class="userpic-placeholder" v-if="userStore.userPic.type === 'text'">
              <span>{{ userStore.userPic.data }}</span>
            </div>
          </figure>
        </div>
        <button class="mobile-menu-button" @click="menuFolded = !menuFolded">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path v-if="menuFolded" d="M11 6.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-8zm-6 5a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h14a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75H5zm6 5a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-8z"/>
            <path v-else d="M6 5.25a.75.75 0 0 0-.531.219.75.75 0 0 0 0 1.062L10.937 12 5.47 17.469a.75.75 0 0 0 0 1.062.75.75 0 0 0 1.062 0L12 13.063l5.469 5.468a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.062L13.063 12l5.468-5.469a.75.75 0 0 0 0-1.062A.75.75 0 0 0 18 5.25a.75.75 0 0 0-.531.219L12 10.937 6.531 5.47A.75.75 0 0 0 6 5.25z"/>
          </svg>
        </button>
      </div>
    </div>
    <div :class="['mobile-menu', menuFolded ? 'folded' : '']" @click="menuFolded = !menuFolded">
      <RouterLink v-if="!userStore.isLoggedIn" :to="{ name: 'signIn' }">Login</RouterLink>
      <RouterLink v-if="!userStore.isLoggedIn" :to="{ name: 'signUp' }">Sign Up</RouterLink>
      <a href="http://clear.co/partner/patternfast" target="_blank">Funding</a>
      <RouterLink :to="{ name: 'faq' }">FAQs</RouterLink>
      <RouterLink :to="{ name: 'pricing' }">Pricing</RouterLink>
      <template v-if="userStore.isLoggedIn">
        <RouterLink :to="{ name: 'userCollections' }">Collections</RouterLink>
        <RouterLink :to="{ name: 'manufacturing' }">Manufacturing</RouterLink>
        <RouterLink :to="{ name: 'fitModels' }">Fit Models</RouterLink>
        <RouterLink :to="{ name: 'fitChartsCustom' }">Fit charts</RouterLink>
        <RouterLink :to="{ name: 'surfaceDesignColors' }">Surface Design</RouterLink>
        <RouterLink :to="{ name: 'user_team' }">My team</RouterLink>
        <RouterLink :to="{ name: 'userProfile' }">My profile</RouterLink>
        <RouterLink v-if="userStore.data.role === 'MANAGER'" :to="{ name: 'user_billing' }">Billing</RouterLink>
        <span @click="sendLogout()">Log out</span>
      </template>
    </div>
  </header>
</template>

<script>
import { RouterLink } from 'vue-router'
import { mapStores } from 'pinia'
import { logout } from '@/api'
import { useUserStore } from '../../store/pinia/user'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'

export default {
  name: 'TheHeader',
  components: {
    RouterLink,
    ButtonPrimary,
    ButtonSecondary,
  },
  props: {
    scrollY: {
      type: Number,
      default: 800,
    },
    logoColor: {
      type: String,
      default: '#000',
    },
  },
  data: () => ({
    headerScrolled: false,
    menuFolded: true,
  }),
  computed: mapStores(useUserStore),
  methods: {
    logoNav () {
      if (this.$route.name !== 'home') this.$router.push({ name: 'home' })
    },
    scroll () {
      this.headerScrolled = window.scrollY >= this.scrollY
    },
    async sendLogout () {
      try {
        await logout()
        window.location.pathname = '/'
      } catch (e) {
        alert('Failed to log out, please try again')
      }
    },
  },
  created () {
    window.addEventListener('scroll', this.scroll)
    this.scroll()
  },
  beforeMount () {
    this.userStore.get()
  },
  unmounted () {
    window.removeEventListener('scroll', this.scroll)
  },
}
</script>

<style lang="scss">
header.info-pages {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  transition: all 300ms ease-in-out;
  background-color: transparent;
  border-bottom: 1px solid transparent;

  &.scrolled {
    background-color: var(--Background);
    border-bottom: 1px solid var(--Dividers);

    img.white {
      opacity: 0 !important;
    }
    img.color {
      opacity: 1 !important;
    }

    nav a {
      color: var(--Primary-Button-Surface) !important;
    }

    .profile {
      color: var(--Text-Text_Primary) !important;
    }

    .mobile-menu-button svg {
      fill: var(--Primary-Button-Surface) !important;
    }
  }

  .container {
    padding: 10px 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    cursor: pointer;
  }

  .nav-profile {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 25px;
    &__buttons {
      display: flex;
      flex-direction: row;
      gap: 12px;
    }
  }

  nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 25px;

    a, a:visited {
      color: var(--Basic-White);
      font-family: "DM Sans";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      transition: color 300ms ease-in-out;
    }
  }

  .profile {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    color: var(--Basic-White);

    font-family: "DM Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    figure {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      overflow: hidden;
      margin: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .userpic-placeholder {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
        background: var(--avatar-background-shades-1);

        color: var(--Text-Text_White);
        font-family: "DM Sans";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

    }
  }
  .mobile-menu, .mobile-menu-button {
    display: none;
  }
}

@media (max-width: 480px) {
  header.info-pages {
    .container {
      padding: 20px 20px 10px 20px;
    }

    .nav-profile {
      gap: 16px;
      &__buttons {
        button:first-child {
          display: none;
        }
      }
    }

    nav a {
      display: none;
    }
    .profile .name {
      display: none;
    }

    .mobile-menu {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 24px;
      width: 100%;
      height: auto;
      position: absolute;
      z-index: -1;
      width: 100%;
      top: 0;
      left: 0;
      padding-top: 106px;
      padding-bottom: 24px;
      background: var(--Basic-White);

      transition: transform ease-in-out 100ms;

      &.folded {
        transform: translateY(-100%);
      }

      a, span {
        color: var(--Primary-Shades-Primary);
        text-align: center;

        font-family: "DM Sans";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        cursor: pointer;
      }
    }
    .mobile-menu-button {
      display: block;
      width: 24px;
      height: 24px;
      border: none;
      background: transparent;

      svg {
        display: block;
        width: 100%;
        height: 100%;
        fill: var(--Basic-White);
      }
    }
  }
}
</style>
